import React from "react";
import { Button } from "nq-component";
import CardView from "../../../../components/common/CardView";
import InputFactory from "../../../../components/InputFactory";
import BasePage from "../../../../base/BasePage";
import { upsertUseCase } from "../../../../usecases/object";
import {
  FloatingForm,
  formatDate,
} from "../../../../components/common/Converter";
import MultipleSelectHierarchy from "../../../../components/common/MultipleSelectHierarchy";
import BaseFormPage from "../../../../base/BaseFormPage";
import FormFactory from "../../../../components/FormFactory";

function formatForDateTimeLocal(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return "";
  }

  // Get local date-time string in ISO format and slice to required format
  const localDateTime = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000,
  )
    .toISOString()
    .slice(0, 16); // Takes YYYY-MM-DDTHH:mm

  return localDateTime;
}

export default class SuspensionForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      description: "",
      dateFrom: "",
      dateTo: "",
      attachments: [],
    };
  }

  componentDidMount() {
    const { object } = this.props;
    if (Object.keys(object).length > 0) {
      this.setState({
        ...object,
        // description: object.description,
        // dateFrom: formatForDateTimeLocal(object.dateFrom),
        // dateTo: formatForDateTimeLocal(object.dateTo),
        // attachments: object.attachments || [],
      });
    }
  }

  getCollectionName() {
    return "suspension";
  }

  fields = [
    "selectedregions",
    "selectedoffices",
    "selecteddivisions",
    "selectedsections",
    "selectedunits",
    "selectedplantilla",
  ];

  async handleHierarchyChange(hierarchy) {
    const filteredData = Object.keys(hierarchy)
      .filter((key) => this.fields.includes(key)) // Keep only matching keys
      .reduce((acc, key) => {
        const newKey = key.replace("selected", ""); // ✅ Remove "selected" prefix
        acc[newKey] = hierarchy[key]; // ✅ Store with modified key
        return acc;
      }, {});
    this.setState({ ...filteredData });
  }

  handleClickOk() {
    const { dateFrom, dateTo, from, to, ...object } = this.state;

    if (dateFrom > dateTo) {
      this.showError("Date from cannot be greater than date To");
      return;
    }

    const data = {
      dateFrom,
      dateTo,
      type: "Work Suspension",
      status: "active",
      from: new Date(dateFrom),
      to: new Date(dateTo),
      ...object,
    };
    // if (!data.regions || data.regions.length === 0) {
    //   this.showError("Organization Structure required");
    //   return;
    // }

    if (this.state.id) {
      data.id = this.state.id;
    }

    upsertUseCase().execute("suspension", data);
    this.props.closeCollection();
    this.showSuccess("You have successfully Add new suspension!");
    this.props.refetchData();
  }

  onChange(value, field) {
    // this.presenter.onChange(value, field);
    this.setState({ [field]: value });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const isView = this.props.status === "view";
    return (
      <>
        <FloatingForm width="30rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-6 fw-bold pt-3 ps-3">Details</h4>
            <hr />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.handleClickOk();
              }}
            >
              <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                <FormFactory
                  className="col-lg-12 p-1"
                  schema={schema}
                  object={this.state}
                  disabled={isView}
                  onChange={this.onChange.bind(this)}
                  // excludeFields={father}
                />

                <div className="mt-3">
                  <MultipleSelectHierarchy
                    className="col-lg-6"
                    object={this.props.object}
                    required={true}
                    disabled={isView || this.state.selectAll}
                    handleObjectChange={this.handleHierarchyChange.bind(this)}
                  />
                </div>

                <InputFactory
                  // object={this.state.attachments}
                  value={this.state.attachments}
                  // required
                  type="File"
                  field="attachments"
                  disabled={isView}
                  onChange={(val) => this.onChange(val, "attachments")}
                />
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                {isView ? (
                  <Button
                    className="btn btn-primary fs-sm"
                    onClick={() => this.props.closeCollection()}
                  >
                    Close
                  </Button>
                ) : (
                  <>
                    <Button
                      className="btn btn-light fs-sm"
                      type="button"
                      onClick={() => this.props.closeCollection()}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btn-primary"
                      type="submit"
                      // onClick={this.handleClickOk.bind(this)}
                    >
                      {this.props.status === "edit" ? "Update" : "Add"}
                    </Button>
                  </>
                )}
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
